import { createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { LeaseAutoPaymentsRepository } from '~/repositories/leaseAutoPaymentsRepository';

export const [LeaseAutoPaymentsProvider, useLeaseAutoPayments] = createMagicDoorContext('LeaseAutoPayments', () => {
  const repo = new LeaseAutoPaymentsRepository();

  const [autoPaymentsResource, getAutoPayments] = createTriggerResource(async (leaseId: string) => {
    return await repo.getAutoPayments(leaseId);
  });

  return {
    autoPaymentsResource,
    getAutoPayments,
  };
});
